import axios from 'axios';
import API from './API';


export const Rooms_Add = (data) => API.post('Rooms/Add', data);
export const Rooms_Get_All = () => {
  return API.get("Rooms/Get_All");
};
export const Rooms_Get = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Rooms/Get/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Rooms_Update = (ID, Data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Rooms/Update/${ID}`, Data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Rooms_Delete = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.delete(`Rooms/Delete/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}


export const Rooms_Restore_Single = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Rooms/Restore/${ID}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${Token}`
      }
    });
}
